import {orderStatusFilter, OrderStatusFilter} from "./OrderStatusFilter";
import {workingOrderListOrderByPipe, WorkingOrderListOrderByPipe} from "./WorkingOrderListOrderByPipe";
import {orderModelStatus, OrderModelStatus} from "./OrderModelStatusPipe";
import {orderLifetime, OrderLifetimeId} from "./LifetimePipe";
import {pricingInstruction, PricingInstructionId} from "./PricingInstructionPipe";
import {sidePipe, SidePipeId, sideShortPipe, SideShortPipeId} from "./SidePipe";
import {optionTypePipe, OptionTypePipeId, optionTypeShortPipe, OptionTypeShortPipeId} from "./OptionTypePipe";
import {optionStylePipe, OptionStylePipeId, optionStyleShortPipe, OptionStyleShortPipeId} from "./OptionStylePipe";
import {conditionPipe, ConditionPipeId} from "./ConditionPipe";

export default angular.module("tfApp.orders.filters", [])
                      .filter(ConditionPipeId, conditionPipe)
                      .filter(OrderStatusFilter, orderStatusFilter)
                      .filter(WorkingOrderListOrderByPipe, workingOrderListOrderByPipe)
                      .filter(OrderModelStatus, orderModelStatus)
                      .filter(OrderLifetimeId, orderLifetime)
                      .filter(PricingInstructionId, pricingInstruction)
                      .filter(SidePipeId, sidePipe)
                      .filter(SideShortPipeId, sideShortPipe)
                      .filter(OptionStylePipeId, optionStylePipe)
                      .filter(OptionStyleShortPipeId, optionStyleShortPipe)
                      .filter(OptionTypePipeId, optionTypePipe)
                      .filter(OptionTypeShortPipeId, optionTypeShortPipe)
                      .name;
